import axios from 'axios';


const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' }
})

export class PowetranzFetchAPI {
    //Funtion to void a transaction by txId in powertranz
    static async void(data, headers) {
        const res = await server(`/powertranz/void`, {
            method: "post",
            data: data,
            headers: headers,

        });
        return res;
    }

    static async refund(data, headers) {
        const res = await server(`/powertranz/refund`, {
            method: "post",
            data: data,
            headers: headers,

        });
        return res;
    }

     static async capture(data, headers) {
        const res = await server(`/powertranz/capture`, {
            method: "post",
            data: data,
            headers: headers,

        });
        return res;
    }

}